import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialButtons from "../SocialButtons/index";
import RefundCancellationPolicy from "../RefundCancellationPolicy/index";
import TermsConditionsModal from "../TermsConditionsModal/index";
import { AiFillShop } from "react-icons/ai";
import { GiCandlestickPhone } from "react-icons/gi";
import { FiSmartphone } from "react-icons/fi";
import { MdEmail } from "react-icons/md";
import { useHistory } from "react-router-dom";
import "./styles.scss";
import PrivacyPolicy from "../PrivacyPolicy";
import OurStory from "../OurStory/index";
import DeliveryOption from "../DeliveryOptions";

export default function Footer(props) {
  const history = useHistory();
  const { isMobile, setCloseModal, closeModal } = props;
  const [showRefundCancellation, setShowRefundCancellationPolicy] = useState(
    false
  );
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showOurStory, setShowOurStory] = useState(false);
  const [showDeliveryOptions, setShowDeliveryOptions] = useState(false);

  return (
    <>
      <div className="footer-container text-left">
        <Container className={isMobile ? "d-block" : "d-flex"}>
          <Col className="footer-col">
            <Row className="footer-title ">Store Location</Row>
            <Row>
              <div className="d-flex justify-content-center w-100">
                <iframe
                  title="maps"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14016.357633203035!2d77.2453167!3d28.5670778!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdc4fbba5af658c4d!2sSindhi%20Dry%20Fruits!5e0!3m2!1sen!2sin!4v1597086311832!5m2!1sen!2sin"
                  width="90%"
                ></iframe>
              </div>
            </Row>
          </Col>
          <Col className="footer-col">
            <Row className="footer-title">Useful Links</Row>
            <Row
              className="footer-links"
              onClick={() => {
                setCloseModal(() => {
                  history.push({ hash: "" });
                  setShowOurStory(false);
                });
                history.push({ hash: "#our-story" });
                setShowOurStory(true);
              }}
            >
              Our Story
            </Row>
            <Row
              className="footer-links"
              onClick={() => {
                setCloseModal(() => {
                  history.push({ hash: "" });
                  setShowDeliveryOptions(false);
                });
                history.push({ hash: "#delivery-options" });
                setShowDeliveryOptions(true);
              }}
            >
              Delivery Options
            </Row>
            <Row
              className="footer-links"
              onClick={() => {
                setCloseModal(() => {
                  history.push({ hash: "" });
                  setShowTermsAndConditions(false);
                });
                history.push({ hash: "#terms-conditions" });
                setShowTermsAndConditions(true);
              }}
            >
              Terms & Conditions
            </Row>
            <Row
              className="footer-links"
              onClick={() => {
                setCloseModal(() => {
                  history.push({ hash: "" });
                  setShowPrivacyPolicy(false);
                });
                history.push({ hash: "#privacy-policy" });
                setShowPrivacyPolicy(true);
              }}
            >
              Privacy Policy
            </Row>

            <Row
              className="footer-links"
              onClick={() => {
                setCloseModal(() => {
                  setShowRefundCancellationPolicy(false);
                  history.push({ hash: "" });
                });
                history.push({ hash: "#refund-cancellation-policy" });
                setShowRefundCancellationPolicy(true);
              }}
            >
              Refund & Cancellation Policy
            </Row>
          </Col>
          <Col className="footer-col">
            <Row className="footer-title mb-3">Contact Us</Row>
            <Row className="primary-color mt-2">
              <div className="d-flex align-items-center">
                <AiFillShop size={50} className="mr-2" />
                <div>
                  K 14, Feroze Gandhi Road Central Market Lajpat Nagar II New Delhi 110024
                  Opposite Multi Level Parking
                </div>
              </div>
            </Row>
            <Row className="primary-color mt-2">
              <div className="d-flex align-items-center">
                <GiCandlestickPhone size={30} className="mr-2" />
                <a href="tel:011-40018195">011-40018195</a>
              </div>
            </Row>
            <Row className="primary-color mt-2">
              <div className="d-flex align-items-center">
                <FiSmartphone size={30} className="mr-2" />
                <a href="tel:+91-8178474593">+91-8178474593</a>
              </div>
            </Row>
            <Row className="primary-color mt-2">
              <div className="d-flex align-items-center">
                <MdEmail size={30} className="mr-2" />
                <a href="mailto:sindhidryfruitimpex@gmail.com">
                  sindhidryfruitimpex@gmail.com
                </a>
              </div>
            </Row>
          </Col>
          <Col className="footer-col">
            <Row className="footer-title">Social Media</Row>
            <SocialButtons isMobile={isMobile} />
          </Col>
        </Container>
        <RefundCancellationPolicy
          open={showRefundCancellation}
          closeModal={closeModal}
        />
        <PrivacyPolicy open={showPrivacyPolicy} closeModal={closeModal} />
        <TermsConditionsModal
          open={showTermsAndConditions}
          closeModal={closeModal}
        />
        <OurStory showOurStory={showOurStory} closeModal={closeModal} />
        <DeliveryOption open={showDeliveryOptions} closeModal={closeModal} />
      </div>
    </>
  );
}
